import React, {useCallback, useMemo, useRef} from 'react';

import {Box} from '@buncha/components/core/view';
import {ItemDetailedDescription} from '@buncha/itemDetails/types/ReplacementItemDetails';
import ItemDetails from './ItemDetails';
import {StyleSheet} from 'react-native';
import Tab from '@buncha/components/composites/Tabs/Tab';
import {TabData} from '@buncha/components/composites/Tabs/type';
import {TabNode} from '@buncha/components/shared/TabNode';
import {useReplacementItemDetailsContext} from '@buncha/itemDetails/hooks/ReplacementItemDetail';

interface ItemDescriptionProps {
  storeIndex?: string;
}

const ItemDescription: React.FC<ItemDescriptionProps> = props => {
  const {state} = useReplacementItemDetailsContext();
  const storeIndex =
    state?.runData?.store?.elasticSearchIndex || props?.storeIndex || '';
  const isMenuStore = Boolean(storeIndex?.length) === false;
  const description = useMemo(() => {
    let descp: ItemDetailedDescription[];
    if (isMenuStore)
      descp = [
        {
          key: 'description',
          name: 'description',
          data: state?.item?.description,
        },
      ];
    else descp = state?.item?.itemDescription || [];
    return descp;
  }, [isMenuStore, state?.item?.description, state?.item?.itemDescription]);
  const tabData = useMemo(
    () =>
      description?.map((item: ItemDetailedDescription) => {
        return {key: item?.name, data: item?.name};
      }),
    [description],
  );
  const [allCategories, sectionData] = useMemo(() => {
    const categories: {[category: string]: number} = {};
    const sectData: {[name: string]: ItemDetailedDescription} = {};
    description?.forEach((item, index) => {
      categories[item.name] = index;
      sectData[item.name] = item;
    });
    return [categories, sectData];
  }, [description]);

  const sections = useMemo(() => {
    const sects: {[key: string]: React.ReactElement} = {};
    for (const category in allCategories)
      sects[category] = <ItemDetails item={sectionData[category]} />;
    return sects;
  }, [allCategories, sectionData]);

  const tabNode = useCallback((info: TabData<any>, activeKey: string) => {
    return <TabNode info={info} activeKey={activeKey} />;
  }, []);

  const keyRef = useRef('');

  const key = useMemo(() => {
    let newKey = '';
    for (let params of tabData || []) newKey += params.key;
    return newKey;
  }, [tabData]);

  if (keyRef.current !== key) keyRef.current = key;
  if (!description?.length) return <></>;
  return (
    <Box>
      <Tab
        key={keyRef.current}
        tabData={tabData || []}
        sections={sections}
        style={styles.tabContainer}
        tabNode={tabNode}
        isScrollable={true}
      />
    </Box>
  );
};

export default React.memo(ItemDescription);

const styles = StyleSheet.create({
  tabContainer: {marginLeft: -3},
});
